import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import {isNil} from "lodash"

import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import {IconTypes} from "@irati/ui/src/Icon"

import {
  FlexWrapper,
  ImagePreview,
  ImageWrapper,
  FlexColumn,
  DeleteButton,
  StyledIcon
} from "./styled/UploadedImage"

class UploadedImage extends PureComponent {
  static propTypes = {
    image: PropTypes.string,
    onDelete: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired
  }
  static defaultProps = {
    image: null
  }

  render() {
    const {image, onDelete, formatMessage} = this.props

    if (isNil(image)) return null

    return (
      <FlexWrapper>
        <ImageWrapper>
          <ImagePreview
            alt={formatMessage({id: "admin.companyBenefits.settings.uploadedImage.preview.alt"})}
            src={image} />
        </ImageWrapper>
        <FlexColumn>
          <DeleteButton small onClick={onDelete}>
            <StyledIcon icon={IconTypes.bin} />
            <FormattedMessage id="admin.companyBenefits.settings.uploadedImage.deleteButton.text" />
          </DeleteButton>
        </FlexColumn>
      </FlexWrapper>
    )
  }
}

export default injectIntl(UploadedImage)
